import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SentooService {
  private encryptedDataSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(undefined);
  private sentooTransactionSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(undefined);
  private countrySubject: BehaviorSubject<string> = new BehaviorSubject<string>(
    undefined
  );

  constructor() {}

  getEncryptedData(): Observable<string> {
    return this.encryptedDataSubject.asObservable();
  }
  getCountry(): Observable<string> {
    return this.countrySubject.asObservable();
  }

  getSentooTransaction(): Observable<string> {
    return this.sentooTransactionSubject.asObservable();
  }

  setEncryptedData(transactionId: string) {
    this.extractSentooTransactionAndCountry(transactionId);
    this.encryptedDataSubject.next(transactionId);
  }

  private extractSentooTransactionAndCountry(transactionId: string) {
    const searchParams = new URLSearchParams(transactionId);

    const sentooTransaction = this.extractSentooTransaction(searchParams);
    const country = this.extractCountry(searchParams);
    this.sentooTransactionSubject.next(sentooTransaction);
    this.countrySubject.next(country);
  }

  private extractSentooTransaction(searchParams: URLSearchParams): string {
    return searchParams?.get('sentoo-transaction');
  }

  private extractCountry(searchParams: URLSearchParams): string {
    return searchParams?.get('country');
  }
}
